import { render, staticRenderFns } from "./AboutUsDesktop.vue?vue&type=template&id=13cb6570&scoped=true"
import script from "./AboutUsDesktop.vue?vue&type=script&lang=js"
export * from "./AboutUsDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb6570",
  null
  
)

export default component.exports